import { render, staticRenderFns } from "./LongRealizedOrdersPopup.vue?vue&type=template&id=df326254&scoped=true&"
import script from "./LongRealizedOrdersPopup.vue?vue&type=script&lang=js&"
export * from "./LongRealizedOrdersPopup.vue?vue&type=script&lang=js&"
import style0 from "./LongRealizedOrdersPopup.vue?vue&type=style&index=0&id=df326254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df326254",
  null
  
)

export default component.exports